<template>
    <div class="container">
        <nav>
            <ol class="breadcrumb p-1 my-1">
                <span class="ml-auto mr-2 text-muted">{{getWorkStatus.data.length}}人</span>
            </ol>
        </nav>
        <div class="card border border-bottom mb-2" v-for="item in getWorkStatus.data" :key="item.id">
            <ul class="list-group list-group-flush">
                <li class="list-group-item px-2 pb-1 pt-3">

                    <!-- 技術者カード -->
                    <work-row :item="item"></work-row>

                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import WorkRow from './WorkRow'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            WorkRow
        },
        computed: {
            ...mapGetters(['getWorkStatus'])
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .opacity0
        opacity: 0
    .wrapper-name
        display:flex
        white-space: nowrap
        .name
            ellipsis()
</style>
